angular.module('unica_relator.relator_controllers')

.controller('RelatorListController', function(
	$rootScope, $scope, $state,
	$confirm,
	RelatorListService, RelatorDeleteService
) {
	$scope.relatorList = [];
	$scope.limit  = 10;
	$scope.offset = 0;
	$scope.canLoad = true;

	$scope.loadRelators = function() {
		$scope.showLoader();
		$scope.canLoad = false;
		RelatorListService
			.list($scope.limit, $scope.offset)
			.then(function(data) {
				$scope.hideLoader();

				if (!data.error) {
					$scope.relatorList = $scope.relatorList.concat( data );
					if ( data.length == 0 ) {
						$scope.canLoad = false;
					} else {
						$scope.canLoad = true;
						$scope.offset = $scope.offset + data.length;
					}
				} else {
					$rootScope.manageError(data);
				}
			});
	};

	$scope.loadRelators();

	$scope.deleteRelator = function(relatorId) {
		$confirm({
			title: 'Sei sicuro di voler eliminare il relatore?',
			text: 'Confermi la cancellazione del relatore?'
		}).then(function() {

			$scope.showLoader();
			RelatorDeleteService
				.delete( relatorId )
				.then(function(data) {
					$scope.hideLoader();

					if (!data.error) {
						angular.forEach($scope.relatorList, function(relator, key) {
							if ( relator.id == relatorId ) {
								$scope.relatorList.splice(key, 1);
							}
						});
						$scope.showSuccessMsg('Relatore eliminato con successo!', '');
					} else {
						$rootScope.manageError(data);
					}

				});

		}, function() {
			// Cancel
		});
	};

})

;